/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { ExportEntryLinksRequestToJSON, ExportExcelFromConfigurationRequestToJSON, ExportKPITableRequestToJSON, ExportModelTableRequestToJSON, SearchCellsRequestToJSON, } from '../models';
/**
 *
 */
var ExportApi = /** @class */ (function (_super) {
    __extends(ExportApi, _super);
    function ExportApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Export list items to excel file
     */
    ExportApi.prototype.exportCellsRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.exportConfigurationId === null || requestParameters.exportConfigurationId === undefined) {
                            throw new runtime.RequiredError('exportConfigurationId', 'Required parameter requestParameters.exportConfigurationId was null or undefined when calling exportCells.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/cells/{exportConfigurationId}/export".replace("{".concat('exportConfigurationId', "}"), encodeURIComponent(String(requestParameters.exportConfigurationId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: SearchCellsRequestToJSON(requestParameters.searchCellsRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Export list items to excel file
     */
    ExportApi.prototype.exportCells = function (exportConfigurationId, searchCellsRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.exportCellsRaw({
                            exportConfigurationId: exportConfigurationId,
                            searchCellsRequest: searchCellsRequest,
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Export entry links to excel file
     */
    ExportApi.prototype.exportEntryLinksRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/dataEntryLinks/export",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: ExportEntryLinksRequestToJSON(requestParameters.exportEntryLinksRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Export entry links to excel file
     */
    ExportApi.prototype.exportEntryLinks = function (exportEntryLinksRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.exportEntryLinksRaw({ exportEntryLinksRequest: exportEntryLinksRequest })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Excel data export from export configuration
     */
    ExportApi.prototype.exportExcelRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.exportConfigurationId === null || requestParameters.exportConfigurationId === undefined) {
                            throw new runtime.RequiredError('exportConfigurationId', 'Required parameter requestParameters.exportConfigurationId was null or undefined when calling exportExcel.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/exportConfiguration/{exportConfigurationId}/export".replace("{".concat('exportConfigurationId', "}"), encodeURIComponent(String(requestParameters.exportConfigurationId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: ExportExcelFromConfigurationRequestToJSON(requestParameters.exportExcelFromConfigurationRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Excel data export from export configuration
     */
    ExportApi.prototype.exportExcel = function (exportConfigurationId, exportExcelFromConfigurationRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.exportExcelRaw({
                            exportConfigurationId: exportConfigurationId,
                            exportExcelFromConfigurationRequest: exportExcelFromConfigurationRequest,
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Export kpi table to excel file
     */
    ExportApi.prototype.exportKPITableRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.widgetId === null || requestParameters.widgetId === undefined) {
                            throw new runtime.RequiredError('widgetId', 'Required parameter requestParameters.widgetId was null or undefined when calling exportKPITable.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/widgets/{widgetId}/export".replace("{".concat('widgetId', "}"), encodeURIComponent(String(requestParameters.widgetId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: ExportKPITableRequestToJSON(requestParameters.exportKPITableRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Export kpi table to excel file
     */
    ExportApi.prototype.exportKPITable = function (widgetId, exportKPITableRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.exportKPITableRaw({
                            widgetId: widgetId,
                            exportKPITableRequest: exportKPITableRequest,
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Export model table to excel file
     */
    ExportApi.prototype.exportModelTableRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.exportConfigurationId === null || requestParameters.exportConfigurationId === undefined) {
                            throw new runtime.RequiredError('exportConfigurationId', 'Required parameter requestParameters.exportConfigurationId was null or undefined when calling exportModelTable.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/sheetRows/{exportConfigurationId}/export".replace("{".concat('exportConfigurationId', "}"), encodeURIComponent(String(requestParameters.exportConfigurationId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: ExportModelTableRequestToJSON(requestParameters.exportModelTableRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Export model table to excel file
     */
    ExportApi.prototype.exportModelTable = function (exportConfigurationId, exportModelTableRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.exportModelTableRaw({
                            exportConfigurationId: exportConfigurationId,
                            exportModelTableRequest: exportModelTableRequest,
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ExportApi;
}(runtime.BaseAPI));
export { ExportApi };
